import { isValidDomain } from '../isValidDomain';

export function validateDomainList(list?: string) {
  if (!list) return true;
  const entries = list.replace(/ +/g, '').split(',');
  return entries.every(isValidDomain);
}
